import React from "react";

import { css, cx } from "@emotion/css";
import MuiSwitch from "@mui/material/Switch";

import { useStyles } from "@/hooks/useStyles.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseSwitchInputProps = {
  value: boolean;
  onChange?: (value: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: "small" | "medium";
};

export type SwitchInputProps = AtomProps<BaseSwitchInputProps, StyleClasses<"root">>;

export const SwitchInput: React.FC<SwitchInputProps> = ({
  id,
  value,
  onChange,
  onBlur,
  className,
  classes,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiSwitch
      id={id}
      checked={value}
      onChange={(event, value) => onChange?.(value, event)}
      onBlur={onBlur}
      className={cx(styles.root, className)}
      {...props}
    />
  );
};

const makeStyles = () => ({
  root: css({}),
});
